
import StatisticsBase from './components/StatisticsBase';
import ChartPc from './components/ChartPc';
import NoData from './components/NoData';

export default {
  i18nComponentKey: 'WidgetProductReviewsStatistics.WidgetProductReviewsStatisticsPc',
  name: 'WidgetProductReviewsStatisticsPc',
  components: { ChartPc, NoData },
  extends: StatisticsBase
};
